export default class ContactFormParser {
  static getFields(data) {
    const fields = [];

    if (data) {
      if (!data.pages) {
        console.log('No pages found in form data.');
        return [];
      }
      data.pages.forEach((page) => {
        if (!page.fieldsets) {
          console.log('No fieldsets found in form data.');
          return [];
        }
        page.fieldsets.forEach((fieldSet) => {
          if (!fieldSet.columns) {
            console.log('No columns found in form data.');
            return [];
          }
          fieldSet.columns.forEach((col) => {
            if (!col.fields) {
              console.log('No fields found in form data.');
              return [];
            }
            col.fields.forEach((field) => {
              fields.push(field);
            });
          });
        });
      });
    }

    return fields;
  }

  static checkIfFieldIsInputText(name) {
    const names = ['Short answer', 'Long answer'];

    let v = false;
    names.forEach((n) => {
      if (n === name) {
        v = true;
      }
    });

    return v;
  }

  static getFieldTypeByUmbracoName(name) {
    const mapping = [
      {
        uName: 'Short answer',
        type: 'input',
      },
      {
        uName: 'Long answer',
        type: 'textarea',
      },
    ];

    let v = '';
    mapping.forEach((entry) => {
      if (entry.uName === name) {
        v = entry.type;
      }
    });

    return v;
  }

  static checkIfFieldTypeIsCheckbox(name) {
    const names = [
      'Checkbox',
      'Process personal information field',
      'Privacy policy field',
    ];

    let v = false;
    names.forEach((n) => {
      if (n === name) {
        v = true;
      }
    });

    return v;
  }
}
